const facilityTypeDatas = window.SIMPL.facilityTypeDatas;

export default function GetfacilityTypeData(facilityType,dataKey, isMarker) {
    // jsonが読み込めていない場合orjsonに定義されていない場合
    if(facilityTypeDatas == null || facilityTypeDatas.length <= 0) return null;

    var typeData = facilityTypeDatas.find(x => x.type === facilityType);

    // 存在しないKeyが指定されている場合
    if(!typeData.hasOwnProperty(dataKey)) return null;

    var isExistsTypeData =  typeData === undefined;

    switch (dataKey){
        case "icon":
            return  "/Icons/" + (isMarker ? "Markers/" : "") 
                + (isExistsTypeData === null ? 
                    null : typeData[dataKey]);
        default:
            return isExistsTypeData ? 
                facilityType : typeData[dataKey];
    }
}